
import ConfigureMoynat from 'https://cid-impl.fluidconfigure.com/moynat/prod/cid-moynat.es.js';
  
function populateCreateMe() {
  const productRecipeId = document.querySelector('#configure-moynat').getAttribute('data-createmeid');
  const recipeOverride = document.querySelector('#configure-moynat').getAttribute('data-recipe-override');
  const price = document.querySelector('.price-item.price-item--regular').textContent.trim();
  const sku = document.querySelector('#configure-moynat').getAttribute('data-sku');
  const lang = document.querySelector('#configure-moynat').getAttribute('data-lang');

  let callLocale = "";
  switch (lang) {
    case 'en': callLocale = "en_UK";
      break;
    case 'zh-CN': callLocale = "zh_CN";
      break;
    default: callLocale = "fr_FR";
  }

  const uniqueID = new Date().getTime();

  const options = {
    id: uniqueID,
    container: '#configure-moynat',
    workflow: 'prod',
    product: productRecipeId,
    recipe: recipeOverride,
    locale: callLocale,
    customData: {
      price: price,
      sku: sku
    }
  };

  const configure = new ConfigureMoynat(options);

  configure.on('cid-add-to-cart', ({info, recipe}) => {
    console.log('info: ', info, ' recipe: ', recipe);
    document.querySelector('personalisation-modal').newRecipe(recipe.id, recipe.customData.sku);
    document.querySelector('offcanvas-menu#personalisation button[name="close"]').click();
  });
}

populateCreateMe();

window.populateCreateMe = populateCreateMe;
